import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/api";
import useReveal from "@/hooks/useReveal";

export default function FinalCta() {
  const ref = useReveal();
  return (
    <section
      ref={ref}
      data-testid="final-cta-section"
      className="relative py-16 sm:py-24 bg-[#B01116] overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-20"
        style={{
          background:
            "repeating-linear-gradient(135deg, transparent 0px, transparent 40px, rgba(0,0,0,0.15) 40px, rgba(0,0,0,0.15) 80px)",
        }}
        aria-hidden="true"
      />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center fade-up">
        <div className="font-accent font-bold text-[#FFC107] tracking-[0.2em] uppercase text-sm mb-4">
          Still Thinking...??
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight tracking-tight">
          Ready to Scale Your Business?
        </h2>
        <p className="mt-5 text-white/85 text-base leading-relaxed max-w-2xl mx-auto">
          Book a free 30-minute strategy call. We&apos;ll audit your funnel and map the
          next 3 months of growth — completely free.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/contact" data-testid="final-cta-button" className="btn-yellow gap-2 text-base px-8 py-4">
            Book Free Strategy Call
            <ArrowRight className="h-4 w-4" />
          </Link>
          <a
            href={`tel:${COMPANY.phone}`}
            data-testid="final-cta-call-button"
            className="btn-outline-white gap-2 text-base px-8 py-4"
          >
            <Phone className="h-4 w-4" />
            Call Us {COMPANY.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
}
